import { render, staticRenderFns } from "./logged-in-base.vue?vue&type=template&id=6d548604&"
import script from "./logged-in-base.vue?vue&type=script&lang=ts&"
export * from "./logged-in-base.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Toast: require('/home/vsts/work/1/s/frontend/components/notification/toast.vue').default})


/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
